const frameworks = [
  { name: 'React', icon: '⚛️' },
  { name: 'Next.js', icon: '▲' },
  { name: 'Vue', icon: '💚' },
  { name: 'Svelte', icon: '🔥' },
  { name: 'Node.js', icon: '💚' },
  { name: 'Python', icon: '🐍' },
  { name: 'Go', icon: '🐹' },
  { name: 'Ruby', icon: '💎' },
]

const codeExamples = {
  react: `// Protect any route with one line
import { RequireAuth } from '@jumpstone/auth-react';

function ProtectedPage() {
  const { user } = useAuth();
  
  return (
    <RequireAuth>
      <h1>Welcome, {user.email}!</h1>
      <Dashboard />
    </RequireAuth>
  );
}`,
  backend: `# Verify tokens server-side
from jumpstone_auth import verify_token

@app.route('/api/protected')
@require_auth  # One decorator
def protected_endpoint():
    user = get_current_user()
    return {"message": f"Hello, {user.email}"}`,
}

export function Integration() {
  return (
    <section className="py-24 bg-surface-950">
      <div className="mx-auto max-w-7xl section-padding">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Content */}
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Integrates with your stack
            </h2>
            <p className="text-lg text-surface-400 mb-8">
              First-class SDKs for every major framework. Drop-in components that match your design system. Full API access for custom implementations.
            </p>

            {/* Framework badges */}
            <div className="flex flex-wrap gap-3 mb-8">
              {frameworks.map((fw) => (
                <div
                  key={fw.name}
                  className="flex items-center gap-2 px-3 py-1.5 bg-surface-800 border border-surface-700 rounded-full text-sm"
                >
                  <span>{fw.icon}</span>
                  <span className="text-surface-300">{fw.name}</span>
                </div>
              ))}
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-accent-emerald/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-3.5 h-3.5 text-accent-emerald" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                </div>
                <div>
                  <p className="text-white font-medium">Pre-built UI components</p>
                  <p className="text-surface-500 text-sm">Login, signup, MFA, and account pages ready to use</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-accent-emerald/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-3.5 h-3.5 text-accent-emerald" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                </div>
                <div>
                  <p className="text-white font-medium">TypeScript-first</p>
                  <p className="text-surface-500 text-sm">Full type safety and autocompletion in your IDE</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-accent-emerald/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-3.5 h-3.5 text-accent-emerald" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                </div>
                <div>
                  <p className="text-white font-medium">Webhooks & events</p>
                  <p className="text-surface-500 text-sm">Real-time notifications for user signup, login, and more</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Code examples */}
          <div className="space-y-4">
            {/* React example */}
            <div className="bg-surface-900 border border-surface-700 rounded-xl overflow-hidden">
              <div className="flex items-center gap-2 px-4 py-2 bg-surface-800/50 border-b border-surface-700">
                <span className="text-xs text-surface-500">Frontend - React</span>
              </div>
              <pre className="p-4 text-sm overflow-x-auto">
                <code className="text-surface-300 whitespace-pre">{codeExamples.react}</code>
              </pre>
            </div>

            {/* Backend example */}
            <div className="bg-surface-900 border border-surface-700 rounded-xl overflow-hidden">
              <div className="flex items-center gap-2 px-4 py-2 bg-surface-800/50 border-b border-surface-700">
                <span className="text-xs text-surface-500">Backend - Python</span>
              </div>
              <pre className="p-4 text-sm overflow-x-auto">
                <code className="text-surface-300 whitespace-pre">{codeExamples.backend}</code>
              </pre>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

